import React from 'react';
import WebHook from '../components/webhook/webHook'

const webhook = () => {
  return <div><WebHook/></div>;
};

export default webhook;
